export enum MedicalDocumentationType {
    GENERALI = 'GENERALI',
    COFUS = 'COFUS',
}
